import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchWarehouses = () => apiActionCreator({
  'endpoint': '/warehouses',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WAREHOUSES_LIST,
    ActionTypes.FETCHED_WAREHOUSES_LIST,
    [
      ActionTypes.FETCHED_WAREHOUSES_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
